const TZ = "Asia/Karachi";

/** Gmail-style list date: time today, "3 Nov" this year, "03/11/25" (day/month/year) before. */
export function listDate(d: Date, now = new Date()): string {
  const day = (x: Date) => x.toLocaleDateString("en-GB", { timeZone: TZ });
  if (day(d) === day(now)) return d.toLocaleTimeString("en-GB", { timeZone: TZ, hour: "numeric", minute: "2-digit", hour12: true });
  const sameYear = d.toLocaleDateString("en-GB", { timeZone: TZ, year: "numeric" }) === now.toLocaleDateString("en-GB", { timeZone: TZ, year: "numeric" });
  return sameYear
    ? d.toLocaleDateString("en-GB", { timeZone: TZ, day: "numeric", month: "short" })
    : d.toLocaleDateString("en-GB", { timeZone: TZ, day: "numeric", month: "numeric", year: "2-digit" });
}

/** One way to write a time and a short date-time everywhere (mail, chat, toasts, Scheduled): "3:34 pm", "Thu 5 Nov, 8:00 am". */
export function timeOfDay(d: Date): string {
  return d.toLocaleTimeString("en-GB", { timeZone: TZ, hour: "numeric", minute: "2-digit", hour12: true });
}
export function shortDateTime(d: Date): string {
  return d.toLocaleString("en-GB", { timeZone: TZ, weekday: "short", day: "numeric", month: "short", hour: "numeric", minute: "2-digit", hour12: true });
}

export function fullDate(d: Date): string {
  return d.toLocaleString("en-GB", { timeZone: TZ, weekday: "short", day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit", hour12: true });
}
